let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("tL1i3")).then(() => parcelRequire('idVd1'));